/* global I18n */

import KenhubModal from "./kenhub_modal"
import React, {useState} from "react"
import change_terminology_language from "change_terminology_language"

function TerminologyModal({on_close, is_open, on_form_submit}) {
  const [selected_terminology, set_selected_terminology] =
    useState(window.gon.current_term_language)

  function on_submit(e) {
    e.preventDefault()
    if (selected_terminology !== window.gon.current_user.term_language) {
      change_terminology_language(
        selected_terminology,
        window.gon.current_user.term_language,
        "terminology_modal"
      ).then(on_form_submit)
    } else {
      on_form_submit()
    }
  }

  if (!window.gon.current_user) return null

  return (
    <KenhubModal
      identifier="terminology"
      class_name="modal-medium terminology-modal"
      label={I18n.t("js.terminology_modal.title")}
      title={I18n.t("js.terminology_modal.title")}
      on_close={on_close}
      is_open={is_open}
    >
      <div className="modal-body">
        <p>{I18n.t("js.terminology_modal.description")}</p>
        <form onSubmit={on_submit}>
          <div className="control-group">
            <RadioButton
              terminology={window.gon.current_term_language}
              selected_terminology={selected_terminology}
              on_change={set_selected_terminology}
            />
            <RadioButton
              terminology={window.gon.alt_term_language}
              selected_terminology={selected_terminology}
              on_change={set_selected_terminology}
            />
          </div>
          <input
            type="submit"
            className="btn btn-primary"
            value={I18n.t("js.terminology_modal.continue")}
          />
        </form>
        <p>{I18n.t("js.terminology_modal.disclaimer")}</p>
      </div>
    </KenhubModal>
  )
}

function RadioButton({terminology, selected_terminology, on_change}) {
  return (
    <>
      <input
        type="radio"
        id={`terminology_${terminology.toLowerCase()}`}
        value={terminology}
        checked={selected_terminology === terminology}
        onChange={() => on_change(terminology)}
      />
      <label htmlFor={`terminology_${terminology.toLowerCase()}`}>
        <span></span>
        {I18n.t(`js.terminology_modal.${terminology.toLowerCase()}`)}
      </label>
    </>
  )
}

export default TerminologyModal
